// extracted by mini-css-extract-plugin
export default {"button":"IconButton_button__AP7kz","notbordered":"IconButton_notbordered__gTZH3","bordered":"IconButton_bordered__OkkPp"};